// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1J9tN","modalFooterButton":"ModalNotes_modalFooterButton__3PhIy"};